import Vue from 'vue'

export default {
  downloadImage: function (url) {
    return Vue.http.get(url, {responseType: 'blob'})
  },
  get: function (apiPath) {
    return Vue.http.get(apiPath)
  },
  put: function (apiPath, apiBody, contentType) {
    let header = null
    if (contentType) {
      header = {'headers': { 'content-type': contentType }}
    }
    return Vue.http.put(apiPath, apiBody, header)
  },
  post: function (apiPath, apiBody, contentType) {
    let header = null
    if (contentType) {
      header = {'headers': { 'content-type': contentType }}
    }
    return Vue.http.put(apiPath, apiBody, header)
  },
  getTimeFromInternet: function () {
    let apiPath = 'http://www.googleapis.com'
    apiPath = 'https://www.googleapis.com'
    return Vue.http.get(apiPath)
  }
}



// WEBPACK FOOTER //
// ./src/apis/common.js